import { TPartialVersionedResource } from "app/queryProvider/interfaces";

export const subscriptionsVersionedResource: TPartialVersionedResource<"subscriptions"> = {
  subscriptions: {
    name: "subscriptions",
    version: "v1",
    microService: "rpm",
    serializer: null,
  },
};
